import * as yup from 'yup';
import {
  FIELD_EMAIL,
  FIELD_REQUIRED,
  PASSWORDS_DO_NOT_MATCH,
  PASSWORD_MIN_LENGTH,
  phoneUtil,
} from '../../lib/validationUtils';

export const REGISTER_VALIDATION_SCHEMA = yup.object().shape({
  forename: yup.string().required(FIELD_REQUIRED),
  surname: yup.string().required(FIELD_REQUIRED),
  email: yup.string().email(FIELD_EMAIL).required(FIELD_REQUIRED),
  password: yup
    .string()
    .required(FIELD_REQUIRED)
    .min(8, PASSWORD_MIN_LENGTH)
    .required(FIELD_REQUIRED),
  repeatPassword: yup
    .string()
    .oneOf([yup.ref('password')], PASSWORDS_DO_NOT_MATCH)
    .when('password', {
      is: (val: string | undefined) => val?.length ?? -1 > 0,
      then: (schema) => schema.required(FIELD_REQUIRED),
    }),
  phoneNumber: yup
    .string()
    .required(FIELD_REQUIRED)
    .test(
      'phoneNumberCheck',
      'Anna puhelinnumero muodossa "+358..."',
      (phoneNumber) => {
        try {
          return phoneUtil.isValidNumberForRegion(
            phoneUtil.parse(phoneNumber),
            'FI',
          );
        } catch {
          return false;
        }
      },
    ),
});
